import React, { createContext, useContext, useMemo, useState } from "react";
import UpsellModal from "./UpsellModal";

const UpsellContext = createContext(null);

export const useUpsell = () => useContext(UpsellContext);

const UpsellProvider = ({ children }) => {
  const [state, setState] = useState({ isOpen: false, reason: null });

  const value = useMemo(
    () => ({
      isOpen: state.isOpen,
      reason: state.reason,
      open: (reason) => setState({ isOpen: true, reason }),
      close: () => setState({ isOpen: false, reason: null }),
    }),
    [state]
  );

  return (
    <UpsellContext.Provider value={value}>
      {children}
      <UpsellModal />
    </UpsellContext.Provider>
  );
};

export default UpsellProvider;
